/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 
 
 */

jQuery(document).ready(function( $ ) {


(function () {
  // Vertical Tabs
  $('.js-vertical-tab-content').hide();
  $('.js-vertical-tab-content:first').show();

  /* if in tab mode */
  $('.js-vertical-tab').click(function (event) {
    var activeTab;
    event.preventDefault();
    $('.js-vertical-tab-content').hide();
    activeTab = $(this).attr('rel');
    $('#' + activeTab).show();
    $('.js-vertical-tab').removeClass('is-active');
    $(this).addClass('is-active');
    $('.js-vertical-tab-accordion-heading').removeClass('is-active');
    $('.js-vertical-tab-accordion-heading[rel^=\'' + activeTab + '\']').addClass('is-active');
  });

  /* if in accordion mode */
  $('.js-vertical-tab-accordion-heading').click(function (event) {
    var accordion_activeTab;
    event.preventDefault();
    $('.js-vertical-tab-content').hide();
    accordion_activeTab = $(this).attr('rel');
    $('#' + accordion_activeTab).show();
    $('.js-vertical-tab-accordion-heading').removeClass('is-active');
    $(this).addClass('is-active');
    $('.js-vertical-tab').removeClass('is-active');
    $('.js-vertical-tab[rel^=\'' + accordion_activeTab + '\']').addClass('is-active');
  });

}).call(this);


$(document).ready(function() {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions of sales to check out.");
      return false;
    }
  });
});

(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();

    var checkExist = setInterval(function() {
        if ($('#ct_pe_disco').length) {
            $('#ct_pe_disco').appendTo($('.ProductMeta'));
            clearInterval(checkExist);
        }
    }, 100); // check every 100ms    
  
});